import { Button } from '@helvetia/components/Button'
import { Option } from '@helvetia/components/forms/NativeSelect/NativeSelect.types'
import { OptionSelector } from '@helvetia/components/forms/OptionSelector'
import { Col, Row } from '@helvetia/components/layout'
import Spinner from '@helvetia/components/Spinner'
import Text from '@helvetia/components/Text'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { LifecycleView } from '../../_components/ConnectComponent'
import { ExpiredTable } from './ExpiredTable'
import { OfferTable } from './OfferTable'
import { PolicyTable } from './PolicyTable'
import { PortalPresenter } from './Portal.presenter'

export interface View extends LifecycleView {
  showLoading: () => void
  hideLoading: () => void
}

interface Props {
  presenter: PortalPresenter
}

interface State {
  isLoading: boolean
  isOfferTableVisible: boolean
  isPolicyTableVisible: boolean
  isExpiredTableVisible: boolean
  selectorValue: string
}

export class PortalRaw
  extends React.Component<Props & RouteComponentProps & WithNamespaces, State>
  implements View {
  private presenter: PortalPresenter
  private tabOption: Option[]

  constructor(props) {
    super(props)

    this.presenter = props.presenter
    this.presenter.initialize(this)

    this.tabOption = [
      { text: props.t('portal.offer'), value: 'offer' },
      { text: props.t('portal.policy'), value: 'policy' },
      { text: props.t('portal.offerExpired'), value: 'expired' },
    ]

    this.state = {
      isLoading: false,
      isOfferTableVisible: true,
      isPolicyTableVisible: false,
      isExpiredTableVisible: false,
      selectorValue: 'offer',
    }
  }

  componentDidMount() {
    this.tabOption = [
      { text: this.props.t('portal.offer'), value: 'offer' },
      { text: this.props.t('portal.policy'), value: 'policy' },
      { text: this.props.t('portal.offerExpired'), value: 'expired' },
    ]
  }

  showLoading = () => this.setState({ isLoading: true })

  hideLoading = () => this.setState({ isLoading: false })

  changeTabSelection = (tabValue: string) => {
    switch (tabValue) {
      case 'offer':
        this.setState({
          isOfferTableVisible: true,
          isPolicyTableVisible: false,
          isExpiredTableVisible: false,
        })
        break
      case 'policy':
        this.setState({
          isOfferTableVisible: false,
          isPolicyTableVisible: true,
          isExpiredTableVisible: false,
        })
        break
      case 'expired':
        this.setState({
          isOfferTableVisible: false,
          isPolicyTableVisible: false,
          isExpiredTableVisible: true,
        })
        break
    }
    this.setState({ selectorValue: tabValue })
  }

  render() {
    const { t } = this.props
    const {
      isLoading,
      isOfferTableVisible,
      isPolicyTableVisible,
      isExpiredTableVisible,
      selectorValue,
    } = this.state

    if (isLoading) return <Spinner size="xl" />

    return (
      <>
        <Row verticalGutter marginTop="s" marginBottom="m">
          <Col verticalGutter mobile={12} tablet={3} desktop={3}>
            <Button
              primary
              onClick={this.presenter.onNewOffer}
              style={{ justifyContent: 'center', width: '100%' }}
            >
              {t('portal.newOffer')}
            </Button>
          </Col>
        </Row>
        <Row marginBottom="s">
          <OptionSelector
            value={selectorValue}
            optionList={this.tabOption}
            onChange={event =>
              this.changeTabSelection(event.currentTarget.value)
            }
          />
        </Row>
        {isOfferTableVisible && <OfferTable />}
        {isPolicyTableVisible && <PolicyTable />}
        {isExpiredTableVisible && <ExpiredTable />}
      </>
    )
  }
}

export const PortalView = withNamespaces()(withRouter(PortalRaw))
